export default __webpack_public_path__ + "static/media/CV.c2757a9b.pdf";